import script from "./controller.vue?vue&type=script&lang=ts&setup=true"
export * from "./controller.vue?vue&type=script&lang=ts&setup=true"

import "./controller.vue?vue&type=style&index=0&id=5efce18b&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/1/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efce18b"]])

export default __exports__